import React from 'react';

const LoadingSpinner = ({ text, addClasses }) => {
    return (
        <>
            <div className="d-flex justify-content-center mb-3">
                <div className=' bg-tota-blur p-3'>
                    <div className={"spinner-border " + addClasses} role="status">
                        <span className="visually-hidden">loading</span>
                    </div>
                    {text && <div className='w-100 text-center'>{text}</div>}
                </div>
            </div>
        </>
    );
}

export default LoadingSpinner;
